import { useFormikContext } from 'formik'
import { TenantSearchFormValues } from '../types'

export const useTenantSearchFormContext = () => {
  return useFormikContext<TenantSearchFormValues>()
}
